import fetchRetryFactory from "fetch-retry";

const fetchRetry = fetchRetryFactory(fetch);

type Token = string | null;
export let token: Token;
export let tokenPromise: Promise<Token> | null = null;

/**
 * Clears the global CSRF Token state
 */
export function clearCSRFToken(): void {
  token = null;
  tokenPromise = null;
}

/**
 * Sets CSRF Token
 *
 * @param newToken
 */
export function setCSRFToken(newToken: Token): void {
  token = newToken;
}

/**
 * Retrieves CSRF Token
 * If the token is already set by setCSRFToken, use it.
 *
 */
export async function getCSRFToken(): Promise<Token> {
  if (token) {
    return Promise.resolve(token);
  }

  if (!tokenPromise) {
    tokenPromise = fetchRetry("/csrf_token", {
      retryDelay: 500,
      retryOn: (attempt, error, response) => {
        // retry at most 2 times (attempt is 0-indexed)
        if (attempt > 1) {
          return false;
        }
        // retry on any network error, or 4xx or 5xx status codes
        if (error !== null || (response && response.status >= 400)) {
          return true;
        }
        return false;
      },
    })
      .then(async (resp) => {
        if (!resp.ok) {
          throw await resp.json();
        }
        return resp;
      })
      .then((resp) => resp.json())
      .then((json) => {
        setCSRFToken(json.csrfToken);
        return json.csrfToken;
      })
      .catch((ex) => {
        // TODO: log here
        // Throw the error because we can't do anything about it here
        throw ex;
      });
  }

  return tokenPromise;
}
